import { Box, Skeleton } from "@mui/material";

export const MemberCardSkeleton = () => (
  <Box
    sx={{
      width: "50rem",
      margin: "auto",
      minHeight: "50vh",
      padding: "30px",
      borderRadius: "12px",
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
      backgroundColor: "#FFFFFF",
      fontFamily: "Arial, sans-serif",
      textAlign: "left",
      border: "1px solid #E8F4FD",
    }}
  >
    <Skeleton variant="text" width="300px" height={32} sx={{ mb: 3 }} />

    {/* Simulate form fields */}
    {Array.from({ length: 9 }).map((_, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          padding: "12px",
          borderRadius: "8px",
          backgroundColor: "#F8FAFC",
          border: "1px solid #E5E7EB",
        }}
      >
        <Skeleton variant="text" width="100%" height={40} sx={{ flex: 1 }} />
        <Skeleton variant="circular" width={40} height={40} sx={{ ml: 1 }} />
      </Box>
    ))}
  </Box>
);

export const VehicleSkeleton = () => (
  <Box
    sx={{
      width: "50rem",
      margin: "auto",
      minHeight: "50vh",
      padding: "30px",
      borderRadius: "12px",
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
      backgroundColor: "#FFFFFF",
      fontFamily: "Arial, sans-serif",
      border: "1px solid #E8F4FD",
    }}
  >
    <Skeleton variant="text" width="300px" height={32} sx={{ mb: 2.5 }} />

    {/* Vehicle info fields */}
    {Array.from({ length: 4 }).map((_, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 1.5,
          padding: "12px",
          borderRadius: "8px",
          backgroundColor: "#F8FAFC",
          border: "1px solid #E5E7EB",
        }}
      >
        <Skeleton variant="text" width="100%" height={40} sx={{ flex: 1 }} />
        <Skeleton variant="circular" width={40} height={40} sx={{ ml: 1 }} />
      </Box>
    ))}

    {/* Divider */}
    <Skeleton variant="rectangular" width="100%" height={1} sx={{ my: 3 }} />

    {/* Date fields */}
    {Array.from({ length: 2 }).map((_, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 1.5,
          padding: "12px",
          borderRadius: "8px",
          backgroundColor: "#F8FAFC",
          border: "1px solid #E5E7EB",
        }}
      >
        <Skeleton variant="text" width="100%" height={40} sx={{ flex: 1 }} />
        <Skeleton variant="circular" width={40} height={40} sx={{ ml: 1 }} />
      </Box>
    ))}

    {/* Divider */}
    <Skeleton variant="rectangular" width="100%" height={1} sx={{ my: 3 }} />

    {/* Vehicle reminder switch */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px",
        borderRadius: "8px",
        backgroundColor: "#F8FAFC",
        border: "1px solid #E5E7EB",
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="200px" height={20} />
        <Skeleton variant="text" width="280px" height={16} sx={{ mt: 0.5 }} />
      </Box>
      <Skeleton variant="rounded" width={50} height={25} />
    </Box>
  </Box>
);

export const VehicleFormSkeleton = () => (
  <Box
    sx={{
      width: "50rem",
      margin: "auto",
      minHeight: "50vh",
      padding: "30px",
      borderRadius: "12px",
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
      backgroundColor: "#FFFFFF",
      fontFamily: "Arial, sans-serif",
      border: "1px solid #E8F4FD",
    }}
  >
    <Skeleton variant="text" width="400px" height={40} sx={{ mb: 1 }} />
    <Skeleton variant="text" width="200px" height={40} sx={{ mb: 3 }} />

    {/* Form fields */}
    {Array.from({ length: 6 }).map((_, index) => (
      <Skeleton
        key={index}
        variant="rounded"
        width="100%"
        height={56}
        sx={{ mb: 2, backgroundColor: "#F8FAFC" }}
      />
    ))}

    {/* Radio buttons */}
    <Box sx={{ mb: 2 }}>
      <Skeleton variant="text" width="150px" height={20} sx={{ mb: 1 }} />
      <Box sx={{ display: "flex", gap: 2 }}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton
            key={index}
            variant="rounded"
            width={100}
            height={30}
            sx={{ backgroundColor: "#F8FAFC" }}
          />
        ))}
      </Box>
    </Box>

    {/* Submit button */}
    <Skeleton
      variant="rounded"
      width="100%"
      height={48}
      sx={{ mt: 3, backgroundColor: "#E3F2FD" }}
    />
  </Box>
);

export const ProfileSkeleton = () => (
  <Box
    sx={{
      width: "70rem",
      margin: "auto",
      minHeight: "75vh",
      padding: "30px",
      borderRadius: "12px",
      boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.12)",
      backgroundColor: "#FFFFFF",
      fontFamily: "Arial, sans-serif",
      border: "1px solid #E8F4FD",
    }}
  >
    {/* Header */}
    <Skeleton variant="text" width="300px" height={32} sx={{ mb: 3 }} />

    {/* Account Information Section */}
    <Skeleton variant="text" width="200px" height={24} sx={{ mb: 2 }} />

    {/* Profile info fields */}
    {Array.from({ length: 3 }).map((_, index) => (
      <Box
        key={index}
        sx={{
          mb: 1.5,
          padding: "12px",
          borderRadius: "8px",
          backgroundColor: "#F8FAFC",
        }}
      >
        <Skeleton variant="text" width="120px" height={20} />
        <Skeleton variant="text" width="100%" height={20} sx={{ mt: 0.5 }} />
      </Box>
    ))}

    {/* Divider */}
    <Skeleton variant="rectangular" width="100%" height={1} sx={{ my: 3 }} />

    {/* Preferences Section */}
    <Skeleton variant="text" width="250px" height={24} sx={{ mb: 2.5 }} />

    {/* Newsletter switch */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        padding: "16px",
        borderRadius: "8px",
        backgroundColor: "#F8FAFC",
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="180px" height={20} />
        <Skeleton variant="text" width="250px" height={16} sx={{ mt: 0.5 }} />
      </Box>
      <Skeleton variant="rounded" width={50} height={25} />
    </Box>

    {/* Notifications switch */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px",
        borderRadius: "8px",
        backgroundColor: "#F8FAFC",
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="200px" height={20} />
        <Skeleton variant="text" width="280px" height={16} sx={{ mt: 0.5 }} />
      </Box>
      <Skeleton variant="rounded" width={50} height={25} />
    </Box>
  </Box>
);
